import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

interface County {
  name: string;
  slug: string;
  nursing_home_count?: number | null;
}

interface CountyAllCountiesSectionProps {
  currentCountySlug: string;
  currentCountyName: string;
  allCounties: County[];
}

export function CountyAllCountiesSection({
  currentCountySlug,
  currentCountyName,
  allCounties,
}: CountyAllCountiesSectionProps) {
  const otherCounties = allCounties.filter((c) => c.slug !== currentCountySlug);

  if (!otherCounties.length) return null;

  return (
    <div className="bg-white rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold mb-4 text-grandpal-green-dark">
        Browse Nursing Homes in All Other Counties
      </h2>
      <p className="text-sm text-muted-foreground mb-4">
        Not finding what you need in {currentCountyName}? Explore nursing homes across every county in Ireland.
      </p>
      <ul className="flex flex-wrap gap-2">
        {otherCounties.map((county) => (
          <li key={county.slug}>
            <Link
              to={`/nursing-homes/${county.slug}`}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-border text-sm hover:bg-muted hover:border-primary/30 transition-colors"
            >
              <MapPin className="h-3 w-3 text-muted-foreground" />
              {county.name}
              {county.nursing_home_count != null && (
                <span className="text-xs text-muted-foreground">
                  ({county.nursing_home_count})
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs text-muted-foreground">
        <Link
          to="/nursing-homes"
          className="underline underline-offset-2 hover:text-foreground"
        >
          View all nursing homes in Ireland
        </Link>
      </p>
    </div>
  );
}
